<template>
    <div class="max-w-(--breakpoint-sm) flex flex-col gap-4">
        <page-header>Billing Details</page-header>

        <team-billing-email :team-id="team.id" :billing-email="team.billing_email" :is-editable="isEditable" />

        <team-billing-info
            :team-id="team.id"
            :billing-information="{
                billing_company_legal_name: team.billing_company_legal_name,
                billing_address: team.billing_address,
                billing_address_line_2: team.billing_address_line_2,
                billing_city: team.billing_city,
                billing_state: team.billing_state,
                billing_zip: team.billing_zip,
                billing_country: team.billing_country,
                billing_po_number: team.billing_po_number,
            }"
            :is-editable="isEditable"
        />

        <team-stripe-payment-method
            v-if="isEditable && stripeKey"
            :team-id="team.id"
            :payment-method="{ card_brand: team.card_brand, card_last_four: team.card_last_four }"
            :stripe-key="stripeKey"
            :stripe-api-version="stripeApiVersion"
        />
    </div>
</template>

<script setup>
import PageHeader from '~/components/general/PageHeader.vue';
import TeamBillingEmail from '~/components/settings/billing/TeamBillingEmail.vue';
import TeamBillingInfo from '~/components/settings/billing/TeamBillingInfo.vue';
import TeamStripePaymentMethod from '~/components/settings/billing/TeamStripePaymentMethod.vue';
import { computed } from 'vue';

const props = defineProps({
    team: {
        type: Object,
        required: true,
    },
    isAdminOrOwner: {
        type: Boolean,
        default: false,
    },
});

const stripeKey = Spark.stripeKey;
const stripeApiVersion = Spark.stripeApiVersion;

const isEditable = computed(() => props.isAdminOrOwner && props.team.status !== 'closed');
</script>
